export default "__VITE_ASSET__$WYh5b7X__"